/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Farm_RaisedInputs */

const en_attribute_farm_raised = /** @type {(inputs: Attribute_Farm_RaisedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farm raised`)
};

/**
* | output |
* | --- |
* | "Farm raised" |
*
* @param {Attribute_Farm_RaisedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_farm_raised = /** @type {((inputs?: Attribute_Farm_RaisedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Farm_RaisedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_farm_raised(inputs)
});